import type { ImageDataObject } from './service';

export type Image = {
  downloadUrl?: string;
  filename?: string;
  id: string;
  url: string;
};

export const createImage = (data: ImageDataObject): Image => ({
  downloadUrl: data.download_url,
  filename: data.filename,
  id: data.id,
  url: data.url,
});
